// ** Reducers Imports
import navbar from './navbar';
import layout from './layout';
import auth from './authentication';
import permission from './permission';
import crudApis from './allCrudeStore';
import Tabs from './Tabs';
import projectSettings from '../views/ProjectSetting/store';

const rootReducer = {
    auth,
    navbar,
    layout,
    permission,
    projectSettings,
    Tabs,
    ...crudApis
};

export default rootReducer;
